import { __decorate } from "tslib";
import { __metadata } from "tslib";
import { __param } from "tslib";
import { Injectable, Inject, Optional, InjectionToken, NgZone, PLATFORM_ID } from '@angular/core';
import { createStorageRef } from './ref';
import { FirebaseOptionsToken, FirebaseNameOrConfigToken, FirebaseZoneScheduler, _firebaseAppFactory } from '@angular/fire';
export var StorageBucket = new InjectionToken('angularfire2.storageBucket');
var AngularFireStorage = /*@__PURE__*/ (function () {
    function AngularFireStorage(options, nameOrConfig, storageBucket, platformId, zone) {
        this.scheduler = new FirebaseZoneScheduler(zone, platformId);
        this.storage = zone.runOutsideAngular(function () {
            var app = _firebaseAppFactory(options, nameOrConfig);
            return app.storage(storageBucket || undefined);
        });
    }
    AngularFireStorage.prototype.ref = function (path) {
        return createStorageRef(this.storage.ref(path), this.scheduler);
    };
    AngularFireStorage.prototype.upload = function (path, data, metadata) {
        var storageRef = this.storage.ref(path);
        var ref = createStorageRef(storageRef, this.scheduler);
        return ref.put(data, metadata);
    };
    AngularFireStorage = __decorate([
        __param(0, Inject(FirebaseOptionsToken)),
        __param(1, Optional()), __param(1, Inject(FirebaseNameOrConfigToken)),
        __param(2, Optional()), __param(2, Inject(StorageBucket)),
        __param(3, Inject(PLATFORM_ID))
    ], AngularFireStorage);
    return AngularFireStorage;
}());
export { AngularFireStorage };
//# sourceMappingURL=storage.js.map
